module.exports = __webpack_public_path__ + "static/media/13a-05_Tablas-&-camas-2013-285x176mm-oleo-sobre-revista-National-Geographic-y-madera.bb9f8b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13a/13a-05_Tablas-&-camas-2013-285x176mm-oleo-sobre-revista-National-Geographic-y-madera.png
// module id = 131
// module chunks = 0